<template>
  <div class="podium-step">
    <img src="@/assets/crown.png" width="60" height="60" class="crown" v-if="isWinner">
    <div class="step" :style="style">
      <div class="overflowed">
        <img :src="require(`@/assets/${image}.png`)" width="60" height="60" class="medal">
        <div class="text">
          <h1>{{ position }}</h1>
          <h2>{{ user.name }}</h2>
          <i>{{ user.email }}</i>
          <br>
          <i>{{ user.phone }}</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'podium-big-step',
  props: {
    color: String,
    position: Number,
    user: Object
  },
  computed: {
    isWinner: function() {
      return this.position === 1;
    },
    image: function() {
      return {
        1: 'gold-medal',
        2: 'silver-medal',
        3: 'bronze-medal'
      }[this.position];
    },
    style: function() {
      return {
        1: { 'flex-basis': '100%' },
        2: { 'flex-basis': '70%' },
        3: { 'flex-basis': '50%' }
      }[this.position];
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.podium-step {
  position: relative;
  height: 100%;
  justify-content: flex-end;

  .crown {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .step {
    background-color: #b10030;
    height: auto;
    border-radius: 10px;
    margin-top: 30px;

    .overflowed {
      position: relative;
      top: -30px;
    }

    .medal {
      margin-left: auto;
      margin-right: auto;
      display: block;
      border-radius: 50%;
      border: 2px solid #b10030;
      background-color: white;
      padding: 5px;
    }

    .text {
      text-align: center;
      color: white;
    }
  }
}
</style>